import React, { ReactNode } from 'react';
import styles from './Mobile.module.scss';

export const Mobile = ({ children }: Props) => (
    <div className={styles.screen}>
        {children}
    </div>
);

type Props = { children: ReactNode };